import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NavController, NavParams, AlertController, ModalController, IonicModule } from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";

import { SemRegistroComponent } from "src/app/components/sem-registro/sem-registro";
import { ImagePipe } from "src/app/pipes/image/image";
import { EscalaProvider } from "src/app/services/escala/escala";

@Component({
  selector: "app-escala-pessoa-funcao",
  templateUrl: "./escala-pessoa-funcao.page.html",
  styleUrls: ["./escala-pessoa-funcao.page.scss"],
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule, ImagePipe, TranslateModule, SemRegistroComponent],
})
export class EscalaPessoaFuncaoPage implements OnInit {
  pessoas: any = [];
  entidade: string = "";
  idEntidade: string = "";
  idEscala: string = "";
  funcoesPessoa: any = [];
  pagination: any = { currentPage: 0, pageCount: 0 };
  filtro: string = "";
  funcoesList: any = [];
  tipo: string = "";
  isEnsino: any = {};
  processando = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public escalaProvider: EscalaProvider,
    public alertCtrl: AlertController,
    public translate: TranslateService,
    public modalCtrl: ModalController
  ) {
    this.isEnsino = this.navParams.get("isEnsino");
    this.pessoas = this.navParams.get("pessoa");
    this.idEscala = this.navParams.get("idEscala");
    this.entidade = this.navParams.get("entidade");
    this.idEntidade = this.navParams.get("idEntidade");

    this.iniciar();
  }

  ngOnInit() {}

  iniciar() {
    if (this.pessoas.length === 1) {
      this.escalaProvider.getFuncoesPessoa(this.entidade, this.idEntidade, this.pessoas[0].id).subscribe((data) => {
        this.funcoesPessoa = data;
        this.loadFuncoes(null);
      });
    } else {
      this.loadFuncoes(null);
    }
  }

  loadFuncoes(infiniteScroll: any) {
    if (this.entidade == "eventoencontro" && !this.isEnsino) {
      this.tipo = "projeto";
    } else if (this.entidade == "eventoencontro" && this.isEnsino) {
      this.tipo = "ensino";
    } else if (this.entidade == "cultoagenda") {
      this.tipo = "culto";
    }

    this.escalaProvider
      .getFuncoesSemPessoa(this.entidade, this.idEntidade, this.pagination, this.filtro, this.tipo)
      .subscribe((res) => {
        if (!infiniteScroll) {
          this.funcoesList = [];
        }
        const funcoesConvertidas = res.funcoes.map((funcao: any) => {
          funcao.qtdDisponivel = funcao.qtd - funcao.qtdDisponivel;
          return funcao;
        });

        const funcoesFiltradas = funcoesConvertidas.filter(
          (f: any) => !this.funcoesPessoa.some((fp: any) => fp.funcao === f.funcao)
        );

        this.funcoesList = this.funcoesList.concat(funcoesFiltradas);
        this.pagination = res.pagination;
        if (infiniteScroll) infiniteScroll.target.complete();
      });
  }

  onInput() {
    this.loadFuncoes(null);
  }

  async removerFuncao(funcao: { idEscalaFuncaoPessoa: any }) {
    let confirmAlert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: this.translate.instant("Atenção"),
      message: this.translate.instant("Confirmar exclusão?"),
      buttons: [
        {
          text: this.translate.instant("Cancelar"),
          role: "cancel",
        },
        {
          text: this.translate.instant("Sim"),
          handler: () => {
            this.escalaProvider.removerPessoaFuncao(funcao.idEscalaFuncaoPessoa).subscribe((data) => {
              this.iniciar();
            });
          },
        },
      ],
    });
    confirmAlert.present();
  }

  async selecionarFuncao(funcao: { qtdDisponivel: number; id: any; qtd: any }) {
    this.processando = true;
    if (funcao.qtdDisponivel <= funcao.qtd || !this.idEscala) {
      this.escalaProvider
        .addPessoaFuncoes(this.entidade, this.idEntidade, this.pessoas, funcao.id, this.idEscala)
        .subscribe({
          next: (data) => {
            data.success ? this.alert(data.message) : this.iniciar();
          },
          error: (err) => {
            this.processando = false;
          },
          complete: () => {
            this.processando = false;
          },
        });
    } else {
      this.alert(this.translate.instant("Quantidade de vagas insuficiente."));
      this.processando = false;
    }
  }

  async alert(message: string) {
    const confirmAlert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: this.translate.instant("Atenção"),
      message: message,
      buttons: [
        {
          text: this.translate.instant("Entendi"),
          role: "cancel",
        },
      ],
    });
    confirmAlert.present();
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
